<script setup>
import Loader from './core/loader/Loader.vue';
import { computed } from 'vue';
import { loadingState } from '@/core/loader/loading';
import { setupAxiosInterceptors } from '@/core/js/interceptor';
import { Toast } from 'primevue';
import { useToast } from 'primevue/usetoast';
import ConfirmDialog from 'primevue/confirmdialog';
const toast = useToast();
setupAxiosInterceptors(toast);
const isLoading = computed(() => loadingState.isLoading);
</script>
<template>
    <Loader :visible="isLoading" />
    <Toast />
    <ConfirmDialog></ConfirmDialog>
    <router-view />
</template>
<style>
/* .p-button,
.p-inputtext,
.p-textarea,
.p-select {
    border-radius: 0 !important;
} */
</style>
